import React, { useContext, useEffect, useState } from "react";
import UserContext from "../../UserContext";
import { useNavigate } from "react-router-dom";
import "./AdminDashboard.css";
import logo from "../../assets/logo.png";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCalendarDays, faChevronDown, faChevronUp, faGear, faHouse, faMagnifyingGlassChart, faTicket } from "@fortawesome/free-solid-svg-icons";
import user from "../../assets/user.png";
import AccountSettings from "./Customer/AccountSettings/AccountSettings";
import Events from "./Organiser/Events/Events";
import Overview from "./Organiser/Overview/Overview";
import axios from "axios";

const AdminDashboard = () => {
  const navigate = useNavigate();

  const { userInfo, changes,setChanges, authenticated, logout,getUserDetails,userDetails,setUserDetails } = useContext(UserContext);
  const [activeOption, setActiveOption] = useState("overview");
  const [triggetArrowDown, setTriggerArrowDown] = useState(false);
  const [loading, setLoading] = useState(true);
  const isMobile = window.innerWidth <= 768;


  useEffect(() => {
    if (!authenticated || userInfo === null) {
      navigate("/login");
    }
  }, [authenticated, userInfo, navigate]);

  const handleLogout = async () => {
    await logout();
  };

  useEffect(()=> {
    getUserDetails(userInfo.email)
      .then((res) => {
        setLoading(false)
        setUserDetails(res)
        setChanges(false);
      })
      .catch((error) => console.error(error));
  },[changes])



  const handleOptionChange = (e) => {
    setActiveOption(() => e.target.id);
  };

  const handleArrowButton = () => {
    if (triggetArrowDown) setTriggerArrowDown(false);
    else setTriggerArrowDown(true);
  };


  const navigateToHome = () => {
    navigate("/");
  };

  return (
    <div className="dashboard-outer-container">
      <div className="dashboard-container">
        <div className="dashboard-aside-container">
          <div className="dashboard-logo">
            <img
              className="logo-hover"
              onClick={navigateToHome}
              src={logo}
              alt="Logo"
            />
          </div>
          <div
            onClick={(e) => handleOptionChange(e)}
            id="overview"
            className={
              activeOption === "overview"
                ? "dashboard-menu-item menu-active"
                : "dashboard-menu-item"
            }
          >
            Overview
          </div>
          <div
            onClick={(e) => handleOptionChange(e)}
            id="events"
            className={
              activeOption === "events"
                ? "dashboard-menu-item menu-active"
                : "dashboard-menu-item"
            }
          >
            Events
          </div>
          <div
            onClick={(e) => handleOptionChange(e)}
            id="settings"
            className={
              activeOption === "settings"
                ? "dashboard-menu-item menu-active"
                : "dashboard-menu-item"
            }
          >
            Account Settings
          </div>
        </div>
        <div className="dashboard-main-container">
          <div className="dashboard-header">
          <div></div>
            {isMobile ? <div onClick={navigateToHome} className="home-div-mobile"> <FontAwesomeIcon icon={faHouse} style={{color:"#61cdbb"}}/> <h3 className="mobile-home">Home</h3> </div> : <></>}
            <div className="header-icon">
              {loading ? <></>: <img className="user-icon" src={userDetails.picture || user} />}
              {loading ? (
                <></>
              ) : (
                <h4
                  style={
                    !triggetArrowDown
                      ? { margin: "0.5em" }
                      : { display: "none" }
                  }
                >
                  {userDetails.displayName}
                </h4>
              )}
              <h4
                onClick={handleLogout}
                className="logout-menu"
                style={
                  !triggetArrowDown ? { display: "none" } : { margin: "0.5em" }
                }
              >
                Logout
              </h4>
              <FontAwesomeIcon
                onClick={handleArrowButton}
                style={triggetArrowDown ? { display: "none" } : {}}
                className="arrow-icon"
                icon={faChevronDown}
              />
              <FontAwesomeIcon
                style={!triggetArrowDown ? { display: "none" } : {}}
                onClick={handleArrowButton}
                className="arrow-icon"
                icon={faChevronUp}
              />
            </div>
          </div>
          {activeOption === "events" ? (
            <Events />
          ) : activeOption === "settings" ? (
            <AccountSettings />
          ) : activeOption === "overview" ? (
            <Overview />
          ) : (
            <></>
          )}

<div className="dashboard-mobile-footer">
{/* <div className="dashboard-logo">
            {!isMobile ? <img
              className="logo-hover"
              onClick={navigateToHome}
              src={logo}
              alt="Logo"
            />:<div onClick={navigateToHome} className="home-div-mobile"> <FontAwesomeIcon icon={faHouse} style={{color:"#61cdbb"}}/> <h3 className="mobile-home">Home</h3> </div>}
          </div> */}
          <div
            onClick={(e) => handleOptionChange(e)}
            id="overview"
            className={
              activeOption === "overview"
                ? "dashboard-menu-item menu-active"
                : "dashboard-menu-item"
            }
          >
          <FontAwesomeIcon icon={faMagnifyingGlassChart} style={{marginRight:"0.4em"}}/>  Overview
          </div>
          <div
            onClick={(e) => handleOptionChange(e)}
            id="events"
            className={
              activeOption === "events"
                ? "dashboard-menu-item menu-active"
                : "dashboard-menu-item"
            }
          >
           <FontAwesomeIcon icon={faCalendarDays} style={{marginRight:"0.4em"}}/> Events
          </div>
          <div
            onClick={(e) => handleOptionChange(e)}
            id="settings"
            className={
              activeOption === "settings"
                ? "dashboard-menu-item menu-active"
                : "dashboard-menu-item"
            }
          >
           <FontAwesomeIcon  icon={faGear} style={{marginRight:"0.4em"}}/>   Account Settings
          </div>
        </div>
        </div>
      </div>
    </div>
  );
};

export default AdminDashboard;
